<template>
  <section class="holidayTypeAccommodations defaultSectionMargins">
    <div class="container">
      <h2 v-text="data.title" />
  
      <div class="holidayTypeAccommodations__List">
        <SimilarAccommodationsSlider :locations="locations" :flickityOptions="flickityOptions" />
      </div>
    </div>
  </section>
</template>

<script setup>
  const { accommodationsData } = useSetup();
  const props = defineProps({
    data: {}
  });

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };

  const locations = computed(() => {
    return props.data.items.map(item => accommodationsData.value[item.accommodation] || {});
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_holidayTypeAccommodations.scss');
</style>